import React, {useEffect, useState } from "react";
import { useParams, useNavigate ,Link} from "react-router-dom";
import { useFormik } from "formik";
import { detect } from "detect-browser";
import { Filter } from "bad-words";
import * as Yup from "yup";
import { IMaskInput } from 'react-imask';
import ReCAPTCHA from "react-google-recaptcha";
import { toast } from "react-toastify";
import CommonCrypt from "../../Common/CommonCrypt";
import axios from "axios";
import { Container, Row, Col ,Form, Button  } from "react-bootstrap";
import { BtnArrow, BorderPattern, StarIcon ,InstagramIcon, FacebookIcon, XIcon, YoutubIcon , Address ,EmailIcon ,CallIcon } from "../../svgIcon";
import "./_contact-page.scss";
import '../../../../assets/sass/components/_form.scss'

function Contacts({ PageData, ContactInfo, alias, Constant }) {

    const  route  = useParams();
    const APP_URL = window.site_url;
    const [PageContactdata,setContactdata] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const browser = detect();
    const filter = new Filter();
    const googleCaptchaKey = Constant.GOOGLE_CAPTCHA_KEY;
    const navigate = useNavigate(); // Use the useNavigate hook to get the navigate function

    // useEffect(()=>{
    //     console.log(PageData);
    //     setIsLoading(false);
    // },[route]);

    useEffect(() => {
        const data = {
            page: PageData ? PageData : "",
        };
        const fetchData = async () => {
            try {
                const response = await fetch(`${APP_URL}/api/contact-us-page-data`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(data),
                });

                const contact_data = await response.json();
                const contactDecrypted = JSON.parse(CommonCrypt(contact_data.cms_result));
                // console.log(contactDecrypted.partners_data);
                setContactdata(contactDecrypted);
            } catch (error) {
                console.error("Error fetching faqs data:", error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchData();
    }, [route]);

    const formik = useFormik({
        initialValues: {
            first_name: '',
            email: '',
            phone: '',
            varServices: '',
            message: '',
            browserName: browser.name || '',
            osName: browser.os || '',
            type: browser.type || '',
            recapcha: ''
        },
        validationSchema: Yup.object({
            first_name: Yup.string()
                .required('Please enter your name.')
                .test('no-url', 'URLs are not allowed.', value => !/https?:\/\/[^\s]+/.test(value))
                .matches(/^[a-zA-Z\'\’\‘\`\-\–\—\_\s]+$/,'Please enter valid input.')
                .test('no-bad-words', 'Inappropriate language not allowed.', value => !filter.isProfane(value))
                .max(60, 'Must be 60 characters or less.'),
            email: Yup.string()
                .trim()
                .lowercase()
                .test("email-format", "Please enter valid email.", (value) => !value || /^[_A-Za-z0-9\-\–\—]+(\.[_A-Za-z0-9\-\–\—]+)*@[A-Za-z0-9\-\–\—]+(\.[A-Za-z0-9\-\–\—]+)*(\.[A-Za-z]{2,4})$/.test(value))
                .required('Please enter your email.'),
            phone: Yup.string()
                .nullable() // Allows the field to be set to null if left empty
                .notRequired() // Makes the field optional
                .matches(/^[0-9+\-\(\)\s]+$/, 'Please enter a valid phone number.')
                .test('min-digits', 'Phone number must be at least 10 digits.', (value) => !value || value.replace(/\D/g, '').length >= 10)
                .test('max-digits', 'Phone number must not exceed 17 digits.', (value) => !value || value.replace(/\D/g, '').length <= 17)
                .test('not-all-zeros', 'Phone number cannot be all zeroes.', (value) => !value || value.replace(/\D/g, '') !== '0'.repeat(value.replace(/\D/g, '').length))
                .test('not-all-zeros-after-country-code', 'Phone number cannot be all zeros after the country code.', (value) => {
                    if (!value) return true;
                    const digits = value.replace(/\D/g, '');
                    const countryCodeLength = value.startsWith('+') ? value.split(/[\s\(\)\-]/)[0].length : 0;
                    const numberPart = digits.slice(countryCodeLength);
                    return numberPart !== '' && numberPart !== '0'.repeat(numberPart.length);
                }),
            varServices: Yup.string()
                .required('Please select a service.')
                .oneOf(['attractions', 'weddings', 'general'], 'Invalid service selection.'),
            message: Yup.string()
                .test('no-domain-tld','URLs are not allowed.', value => !value || !/^[a-zA-Z0-9\-\.\:\\]+\.(com|org|net|mil|edu|COM|ORG|NET|MIL|EDU)$/.test(value))
                .test('no-url-scheme','URLs are not allowed.', value => !value || !/(ftp|http|https):\/\/(\w+(:\w+)?@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-/]))?/i.test(value))
                .test('no-bad-words', 'Inappropriate language not allowed.', value => !filter.isProfane(value))
                .test('no-html', 'Please enter valid input.', value => !/<\/?[^>]+(>|$)/.test(value))
                .matches(/^[A-Za-z\0-9\'\’\‘\`\-\–\—\_\"\”\“\.\,\!\?\$\&\(\)\"\:\%\'\*\#\@\-\_\s]+$/, 'Please enter valid input.')
                .max(500, 'Must be 500 characters or less.'),
            recapcha: Yup.string().required("Please select I'm not a robot.")
        }),
        onSubmit: async (values, { resetForm }) => {
            document.getElementById('contact_submit').disabled = true;
            setIsLoading(false);
            try {
                await axios.post(`${APP_URL}/api/contact-us`, values);
                resetForm();
                setTimeout(() => {
                    navigate('/thank-you', { state: { message: 'Your message has been successfully sent!', fromSubmission: true } });
                }, 100);
            } catch (error) {
                toast.error("Something went wrong! Please try after some time.");
                console.error('Error submitting form:', error);
                document.getElementById('contact_submit').disabled = false;
            } finally {
                setIsLoading(false);
            }
        },
    });

    const handleRecaptchaChange = (value) => {
        formik.setFieldValue("recapcha", value);
    };

    if (isLoading) {
        return <div></div>;
    }
    return (
        <>
            <section className="contact-us section-gap double-gap overflow-hidden">
                <Container>
                    <Row className="g-0 justify-content-center">
                        <Col xxl={12} className="d-xl-flex">
                        <div className="contact-details text-center d-flex flex-column justify-content-center order-xl-2">
                                <i className="border-pattern d-block w-100 position-absolute bottom-0 end-0 m-auto rotateInfinite360">
                                    <BorderPattern />
                                </i>
                                <h3 className="title mb-3 mb-md-4">Connect with us</h3>

                                <ul className="content list-unstyled mx-auto">
                                    <li className="mb-3 mb-md-4">
                                        <div className="icon mb-2"><i><CallIcon /></i></div>
                                        <p><a href={`tel:${ContactInfo?.varPhoneNo}`} title={`Call Us On ${ContactInfo?.varPhoneNo}`}>{ContactInfo?.varPhoneNo}</a></p>
                                    </li>
                                    <li className="mb-3 mb-md-4">
                                        <div className="icon mb-2"><i><EmailIcon /></i></div>
                                        <p><a href={`mailto:${ContactInfo?.varEmail}`} title={`Mail Us On ${ContactInfo?.varEmail}`}>{ContactInfo?.varEmail}</a></p>
                                    </li>
                                    <li className="mb-3 mb-md-4">
                                        <div className="icon mb-2"><i><Address /></i></div>
                                        <p> {ContactInfo?.txtAddress}</p>
                                    </li>
                                </ul>

                                <div className="social-media">
                                    <ul className="list-unstyled d-flex social-icon justify-content-center">
                                        {
                                            Constant?.SOCIAL_FB_LINK ? (<li><Link to={Constant?.SOCIAL_FB_LINK} title="Follow Us On Facebook" target="_blank"><i className="facebook"><FacebookIcon /></i></Link></li>) : ''
                                        }
                                        {
                                            Constant?.SOCIAL_TWITTER_LINK ? (<li><Link to={Constant?.SOCIAL_TWITTER_LINK} title="Follow Us On X" target="_blank"><i className="twitter"><XIcon /></i></Link></li>) : ''
                                        }
                                        {
                                            Constant?.SOCIAL_YOUTUBE_LINK ? (<li><Link to={Constant?.SOCIAL_YOUTUBE_LINK} title="Follow Us On YouTube" target="_blank"><i className="youtub"><YoutubIcon /></i></Link></li>) : ''
                                        }
                                        {
                                            Constant?.SOCIAL_INSTAGRAM_LINK ? (<li><Link to={Constant?.SOCIAL_INSTAGRAM_LINK} title="Follow Us On Instagram" target="_blank"><i className="instagram"><InstagramIcon /></i></Link></li>) : ''
                                        }
                                    </ul>
                                </div>
                            </div>
                            <div className="contact-box order-xl-1">
                                <Form onSubmit={formik.handleSubmit} id="contactus_form" autoComplete="off">
                                    <Row>
                                        <Col xs={12}>
                                            <div className="mb-4 pb-3 pe-4 pe-md-5 me-xxl-5">
                                                <h3 className="title mb-2">Send us a message</h3>
                                                <div className="cms">
                                                    <p>{ContactInfo?.txtMessage}</p>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="form-group">
                                                <label>Name *</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Name"
                                                    id="first_name"
                                                    name="first_name"
                                                    maxLength="60"
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        if (/^\s+$/.test(value)) {
                                                            formik.setFieldValue("first_name", "");
                                                        } else {
                                                            formik.handleChange(e);
                                                        }
                                                    }}
                                                    onBlur={formik.handleBlur}
                                                    value={formik.values.first_name}
                                                />
                                                {formik.touched.first_name && formik.errors.first_name && <div className="error">{formik.errors.first_name}</div>}
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="form-group">
                                                <label>Email *</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Email"
                                                    id="email"
                                                    name="email"
                                                    maxLength="70"
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        if (/^\s+$/.test(value)) {
                                                            formik.setFieldValue("email", "");
                                                        } else {
                                                            formik.handleChange(e);
                                                        }
                                                    }}
                                                    onBlur={formik.handleBlur}
                                                    value={formik.values.email}
                                                />
                                                {formik.touched.email && formik.errors.email && <div className="error">{formik.errors.email}</div>}
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="form-group">
                                                <label>Phone</label>
                                                <IMaskInput
                                                    mask="+1 (000) 000 0000"
                                                    className="form-control"
                                                    placeholder="Phone"
                                                    id="phone"
                                                    name="phone"
                                                    onAccept={(value) => formik.setFieldValue('phone', value)}
                                                    onBlur={formik.handleBlur}
                                                    value={formik.values.phone}
                                                    />
                                                {formik.touched.phone && formik.errors.phone && <div className="error">{formik.errors.phone}</div>}
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="form-group">
                                                <label>Service *</label>
                                                <select
                                                    type="text"
                                                    className="form-control service-drop"
                                                    placeholder="Service"
                                                    id="varServices"
                                                    name="varServices"
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    value={formik.values.varServices}
                                                >
                                                    <option value=" ">Select Service</option>
                                                    <option value="attractions">Attractions</option>
                                                    <option value="weddings">Weddings Events</option>
                                                    <option value="general">General</option>
                                                </select>
                                                {formik.touched.varServices && formik.errors.varServices && <div className="error">{formik.errors.varServices}</div>}
                                            </div>
                                        </Col>
                                        <Col xs={12}>
                                            <div className="form-group">
                                                <label>Comments</label>
                                                <textarea
                                                    className="form-control"
                                                    placeholder="Comments"
                                                    rows="4"
                                                    id="message"
                                                    name="message"
                                                    maxLength="500"
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        if (/^\s+$/.test(value)) {
                                                            formik.setFieldValue("message", "");
                                                        } else {
                                                            formik.handleChange(e);
                                                        }
                                                    }}
                                                    onBlur={formik.handleBlur}
                                                    value={formik.values.message}
                                                />
                                                {formik.touched.message && formik.errors.message && <div className="error">{formik.errors.message}</div>}
                                            </div>
                                        </Col>
                                        <Col xl={6} lg={12} md={6}>
                                            <div className='g-recaptcha'>
                                                {googleCaptchaKey && (<ReCAPTCHA
                                                    sitekey={googleCaptchaKey} // Pass it conditionally when defined
                                                    onChange={handleRecaptchaChange}
                                                />
                                                )}
                                                {formik.touched.recapcha && formik.errors.recapcha && <div className="error">{formik.errors.recapcha}</div>}
                                            </div>
                                        </Col>
                                        <Col xl={6} lg={12} md={6} className="text-end d-flex align-items-center justify-content-md-end mt-4 mt-md-0">
                                            <div className="d-xl-flex d-lg-block d-md-flex align-items-center justify-content-end h-100 mt-xl-0 mt-lg-4 mt-md-0 mt-4">
                                                <button className="btn btn-primary" id="contact_submit" title="Send a Message">Send a Message
                                                    <BtnArrow />
                                                </button>
                                            </div>
                                        </Col>
                                    </Row>
                                </Form>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
            {Object.values(PageContactdata?.partners_data)?.length > 0 ? (
            <section className="section-gap tour-section-2">
                <Container>
                    <Row className="g-4 g-xl-5 justify-content-center">
                        { Object.values(PageContactdata?.partners_data)?.map((item, index) => (
                            <Col md={6} lg={4} xxl={3} key={index} className="text-center item-wrap">
                                <div className="item rounded-3 p-lg-4 p-3 h-100">
                                    <h6 className="title mb-2">
                                        {item?.tab_section_link ? (
                                            <Link to={item?.tab_section_link} title={item?.tab_section_title} target="_blank">
                                                {item?.tab_section_title}
                                            </Link>
                                        ) : item?.tab_section_title}
                                    </h6>
                                    <div className="cms">
                                        <Link className="mt-0 link-wrapper" to={`tel:${item?.tab_section_phone}`}  title={`Call us on: ${item?.tab_section_phone}`}  target="_blank">{item?.tab_section_phone}</Link>
                                        {/* <p>{item?.tab_section_phone}</p> */}
                                        {item?.tab_section_areadetails?.split("\n")?.map((line, index) => (
                                            <p key={index}>{line}</p>
                                        ))}
                                        {item?.tab_section_link && /*<p>{item?.tab_section_link}</p>*/ <Link className="mt-4 link-wrapper" to={item?.tab_section_link}  title={`Visit us: ${item?.tab_section_link}`}  target="_blank">{item?.tab_section_link}</Link>}
                                    </div>
                                </div>
                            </Col>
                        ))
                        }
                    </Row>
                </Container>
            </section>
            ) : ''}

        </>
    );

}

export default Contacts;
